<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Launcher Management</el-breadcrumb-item>
                <el-breadcrumb-item>Web Form</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title">
                    Web Form
                </div>

            </el-col>
            <el-col :span="8" class="text-right">

            </el-col>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-tabs v-model="activeTab">
                    <el-tab-pane label="Web Forms" name="webForm" v-loading="loadingWebForm">
                        
                        <!-- <el-card  style="margin-top: 24px"  class="box-card">
                            <div slot="header" class="clearfix">
                                <span>Filter</span>
                            </div>
                            <el-row>
                                <el-col :span="6">
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="queryForm.country"
                                            filterable
                                            remote
                                            clearable
                                            auto-complete="nope"
                                            placeholder="Select Country"
                                            :remote-method="searchFormCountry"
                                            :loading="queryForm.searchingCountry"
                                            size="small"
                                            @clear="searchFormCountry('')">
                                        <el-option
                                                v-for="item in formCountries"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="3" style="margin-left: 8px">
                                    <el-button @click="searchWebForm" class="filter-item" size="small" type="primary" icon="el-icon-search">
                                        Search
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-card> !-->

                        <el-card class="box-card" style="margin-top: 24px">
                            <el-row style="margin-bottom: 18px" :gutter="15">
                                <el-col :span="4" :offset="20">
                                    <el-input v-model="queryForm.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                                </el-col>
                            </el-row>
                            <el-table
                                    :data="webForms"
                                    stripe
                                    style="width: 100%">
                                <el-table-column
                                        prop="country.name"
                                        label="GSR Country">
                                </el-table-column>
                                <el-table-column
                                        prop="description"
                                        label="Description">
                                </el-table-column>

                                <el-table-column label="Actions">
                                    <template slot-scope="scope">
                                        <el-button size="mini" icon="el-icon-edit" @click="manage(scope.row.id)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <pagination v-show="queryForm.total>0" :total="queryForm.total" :page.sync="queryForm.page" :limit.sync="queryForm.limit" @pagination="searchWebForm" />
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="Form Entries" name="entries">
                        <el-card  style="margin-top: 24px; margin-bottom: 24px"  class="box-card">
                            <div slot="header" class="clearfix">
                                <span>Filter</span>
                            </div>
                            <el-row :gutter="16">
                                <el-col :span="6">
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="queryEntry.webformFilter"
                                            filterable
                                            remote
                                            clearable
                                            auto-complete="nope"
                                            placeholder="Select Country"
                                            :remote-method="searchWebFormFilter"
                                            :loading="searchingWebformFilter"
                                            size="small"
                                            @change="entryWebformFilterSelected()"
                                            @clear="searchWebFormFilter('')">
                                        <el-option
                                                v-for="item in webformFilters"
                                                :key="item.id"
                                                :label="item.country.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="6">
                                    <el-select
                                            style="width: 100%"
                                            value-key="id"
                                            v-model="queryEntry.template"
                                            filterable
                                            clearable
                                            :disabled="!queryEntry.webformFilter"
                                            auto-complete="nope"
                                            placeholder="Select Template"
                                            :loading="searchingTemplate"
                                            size="small"
                                            @clear="searchTemplates('')">
                                        <el-option
                                                v-for="item in templates"
                                                :key="item.id"
                                                :label="item.versionId"
                                                :value="item.versionId">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="8" style="margin-left: 8px">
                                    <el-button @click="searchWebFormEntries" class="filter-item" size="small" type="primary" icon="el-icon-search">
                                        Search
                                    </el-button>
                                    <a :href="APIUrl + '/public/webForms/' + queryEntry.webformFilter + '/templates/' + queryEntry.template + '.csv'" style="margin-left: 8px">
                                    <el-button class="filter-item" size="small" type="primary" icon="el-icon-printer" :disabled="!queryEntry.template">
                                        Export CSV
                                    </el-button>
                                    </a>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card class="box-card">
                            <el-table
                                    :data="webFormEntries"
                                    stripe
                                    style="width: 100%">
                                <el-table-column
                                        prop="email"
                                        label="User Email">
                                </el-table-column>
                                <el-table-column
                                        prop="deviceID"
                                        label="Device ID">
                                </el-table-column>
                                <el-table-column
                                        prop="countryCode"
                                        label="Country">
                                </el-table-column>
                                <el-table-column
                                        prop="templateVersion"
                                        label="Template Version">
                                </el-table-column>
                                <el-table-column
                                            label="Date">
                                        <template slot-scope="scope" >
                                            {{scope.row.timestamp | formatDateTime}}
                                        </template>
                                    </el-table-column>
                                <el-table-column label="Actions">
                                    <template slot-scope="scope">
                                        <el-button size="mini" icon="el-icon-view" @click="viewEntry(scope.row)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <pagination v-show="queryEntry.total>0" :total="queryEntry.total" :page.sync="queryEntry.page" :limit.sync="queryEntry.limit" @pagination="searchWebFormEntries" />
                        </el-card>
                    </el-tab-pane>
                </el-tabs>

            </el-col>
        </el-row>
        <el-dialog title="View Form Entry" :visible.sync="showWebFormEntry" >
            <div>
                <div class="entry-header">
                    <p style="word-break: normal"><b>Customer</b> : {{viewingEntry.email}}</p>
                    <p style="word-break: normal" class="mt-2"><b>Template Version</b> : {{viewingEntry.templateVersion}}</p>
                    <p class="entry-date"> {{viewingEntry.timestamp | formatDateTime}}</p>
                </div>
                <el-divider/>
                <form-entry-preview :entry="viewingEntry"></form-entry-preview>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showWebFormEntry = false">Close</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import api from "@/services/api/WRCService"
import Pagination from "@/components/Pagination"
import formEntryPreview from '@/components/FormEntryPreview'

export default {
    components: { Pagination, formEntryPreview },
    data: function() {
        return {
            activeTab: 'webForm',
            webForms: [],
            webFormEntries: [],
            loadingWebForm: false,
            loadingWebFormEntries: false,
            formCountries: [],
            showWebFormEntry: false,
            viewingEntry: {},
            webformFilters: [],
            templates: [],
            countryLoading: false,
            searchingWebformFilter: false,
            searchingTemplate: false,
            queryForm: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                country: null,
                searchingCountry: false
            },
            queryEntry: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                email: 0,
                webformId: 0,
                country: null,
                webformFilter: null,
                template: null
            }
        }
    },
    computed: {
        APIUrl: function() {
                return api.getBaseUrl()
            
        }
    },
    methods:{
        search() {
            this.queryForm.page = 1;
            this.searchWebForm();
        },
        manage : function(webFormId) {
            this.$router.push({ name: 'ManageWebForm', params: { webFormId } })
        },
        viewEntry : function(entry) {
            this.viewingEntry = entry

            this.showWebFormEntry = true
        },
        searchWebForm() {
            this.loadingWebForm = true;

            api.getWebForms(this.queryForm.search, {
                page: this.queryForm.page - 1,
                size: this.queryForm.limit
            }).then(({ data }) => {

                this.webForms.splice(0, this.webForms.length);
                this.webForms.push(...data.data.items);
                this.queryForm.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingWebForm = false;
            });
        },
        searchWebFormFilter(query) {
            this.searchingWebformFilter = true;

            api.getWebForms(query, {
                page: 0,
                size: 200
            }).then(({ data }) => {

                this.webformFilters.splice(0, this.webformFilters.length);
                if (query === '') {
                    this.queryEntry.webformFilter = null;
                }
                this.webformFilters.push(...data.data.items);

            }).catch(() => {}).then(() => {
                this.searchingWebformFilter = false;
            });
        },
        searchWebFormEntries() {
            this.loadingWebFormEntries = true;

            api.getWebFormEntries(null, this.queryEntry.template,this.queryEntry.webformFilter, {
                page: this.queryEntry.page - 1,
                size: this.queryEntry.limit
            }).then(({ data }) => {

                this.webFormEntries.splice(0, this.webFormEntries.length);
                this.webFormEntries.push(...data.data.items);
                this.queryEntry.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingWebFormEntries = false;
            });

        },
        exportCSV() {
            

        },
        entryWebformFilterSelected() {
            if (this.queryEntry.webformFilter == null) {
                this.queryEntry.template = null;
            } else {
                this.searchTemplates();
            }
        },
        searchTemplates(query) {
            this.loadingTemplates = true;

            api.getWebFormTemplates(this.queryEntry.webformFilter, {
                page: 0,
                pageSize: 100
            }).then(({ data }) => {

                let templates = data.data.items;

                this.templates.splice(0, this.templates.length);
                if (query === '') {
                    this.queryEntry.template = null;
                }
                this.templates.push(...templates);

            }).catch(() => {}).then(() => {
                this.loadingTemplates = false;
            });
        },
        searchFormCountry(query) {
            this.queryForm.searchingCountry = true;
            api.getCountries(query, {
                page: 0,
                size: 200
            }).then(({data}) => {
                this.formCountries.splice(0, this.formCountries.length);
                if(query === ''){
                    this.formCountries.push({
                        id: null,
                        name: 'Select Country'
                    });

                    this.queryForm.country = null;
                }
                this.formCountries.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.queryForm.searchingCountry = false;
            });
        }
    },
    mounted() {
        this.searchWebForm();
        this.searchWebFormEntries();
        this.searchFormCountry("");
        this.searchWebFormFilter('');
    }
}
</script>

<style scoped>
.entry-header {
    position: relative;
}

.entry-date {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
}
</style>